import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { login } from "../services/oauth";
import axios from "axios";
import { useClearCache } from 'react-clear-cache';
import { Animation, Button, ButtonToolbar, Col, FlexboxGrid, Form, Modal, Notification, Panel, useToaster } from 'rsuite';
import RingLoader from 'react-spinners/PuffLoader'

const useFocus = () => {
    const htmlElRef = React.useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
}
const messageIncorrectLogin = (
    <Notification type="error" header="Error de inicio de sesión" closable>
        <p style={{ width: 320 }}>
            Nombre de usuario o contrase&ntilde;a err&oacute;nea.
        </p>
    </Notification>
);
const messageDisabledUser = (
    <Notification type="error" header="Error de inicio de sesión" closable>
        <p style={{ width: 320 }}>
            Cuenta deshabilitada.
        </p>
    </Notification>
);
const messageIDSError = (
    <Notification type="error" header="Error de red" closable>
        <p style={{ width: 320 }}>
            Ocurri&oacute; un error al contactar al servidor.
        </p>
    </Notification>
);

function LoginPage() {
    const user = useSelector(state => state.auth.user);
    const site = useSelector(state => state.site);
    const [show, setShow] = React.useState(false);
    const [working, setWorking] = useState(false);
    const history = useHistory();
    const [iconLogo, setIconLogo] = useState(null);
    const [statePW, setDefPW] = React.useState('');
    const [passFocus, setPassFocus] = useFocus();
    const [userFocus, setUserFocus] = useFocus();
    const { isLatestVersion, emptyCacheStorage } = useClearCache();
    const [showNewFeatures, setShowNewFeatures] = React.useState(false);
    const { register: loginFrom, handleSubmit } = useForm();
    const toaster = useToaster();
    const abortController = new AbortController();

    const onSubmitLogin = (data) => {
        if (working) return;
        setWorking(true);
        login({ email: data.email, password: statePW })
            .then((result) => {
                if (result.error && result.error.code) {
                    console.log(result.error);
                    setWorking(false);
                    setDefPW("");
                    if (result.error.toString().includes('client is not authorized'))
                        toaster.push(messageDisabledUser, { placement: "topCenter", duration: 5000 });
                    else
                        toaster.push(messageIncorrectLogin, { placement: "topCenter", duration: 5000 });
                    setTimeout(() => setPassFocus(), 500);
                }
                else if (!result.token) {
                    setWorking(false);
                    toaster.push(messageIDSError, { placement: "topCenter", duration: 5000 });
                }
            });
    }

    useEffect(async () => {
        if (user && working) {
            let fd = new FormData();
            fd.append('user_name', user.email);
            fd.append('family_name', user.family_name);
            fd.append('given_name', user.given_name);
            fd.append('sub', user.sub);
            await axios
                .postForm(`${site.site.apiServer}/usuario/activity`, fd, { token: JSON.parse(atob(localStorage.getItem("token"))).at, 'Content-Type': 'multipart/form-data' })
                .finally(() => {
                    setWorking(false);
                    try {
                        var to = new URLSearchParams(window.location.search).get('ret');
                        (to !== undefined && to.length > 0) ? history.push(to) : history.push("/");
                    } catch { history.push("/"); }
                });
        } else if (user) {
            try {
                var to = new URLSearchParams(window.location.search).get('ret');
                (to !== undefined && to.length > 0) ? history.push(to) : history.push("/");
            } catch { history.push("/"); }
        }
    }, [user]);

    useEffect(() => {
        let id = setTimeout(function () {
            setShow(true);
            if (!isLatestVersion) {
                setWorking(true);
                setShowNewFeatures(true);
                setTimeout(() => {
                    emptyCacheStorage();
                }, 1000);
            }
        }, 1000);
        return function cleanup() { window.clearTimeout(id); };
    }, [isLatestVersion]);

    useEffect(() => {
        site.site != null ? (fetch(site.site.apiServer + '/catalogo/res/logo').then((r) => r.text()).then((r) => setIconLogo(r)).catch(() => { })) : void (0);
        return () => abortController.abort();
    }, [site]);

    return (
        <>
            <FlexboxGrid justify="center">
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Animation.Slide in={show} placement="top" onEnter={(node) => { node.style.visibility = 'visible';  } }>
                        <Panel header={
                            <><h3>Iniciar sesi&oacute;n</h3>
                                {iconLogo != null && <div className="brand-logo" dangerouslySetInnerHTML={{ __html: iconLogo }} />}
                                {
                                    (showNewFeatures) &&
                                    (<small style={{ position: "absolute", margin:1, top: 0, left: 0, paddingTop: 3, paddingBottom: 3, paddingInlineStart: 10, paddingInlineEnd: 10, backgroundColor: "#ff0000cc", color: "#ffffff", borderRadius: 5 }}>actualizando ...</small>)
                            }</>
                        } shaded style={{ marginTop: "100px", visibility: "hidden", backgroundColor: "#fff" }} bordered className="wisesoft-login">
                            <Form onSubmit={handleSubmit(onSubmitLogin)} fluid>
                                <Form.Group>
                                    <Form.ControlLabel htmlFor="email">Dirección de email</Form.ControlLabel>
                                    <Form.Control
                                        name="email"
                                        id="email"
                                        type="email"
                                        placeholder="Ingrese su email"
                                        ref={userFocus}
                                        inputRef={loginFrom({ required: true })}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel htmlFor="password">Contraseña</Form.ControlLabel>
                                    <Form.Control
                                        name="password"
                                        id="password"
                                        type="password"
                                        autoComplete="off"
                                        placeholder="Ingrese su constrase&ntilde;a"
                                        inputRef={(loginFrom({ required: true }), passFocus)}
                                        onChange={(e) => { setDefPW(e); }}
                                        value={statePW}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <ButtonToolbar>
                                        <Button type="submit" appearance="primary">INGRESAR</Button>
                                        <Button appearance="link">Olvidó la contraseña?</Button>
                                    </ButtonToolbar>
                                </Form.Group>
                            </Form>
                        </Panel>
                    </Animation.Slide>
                </FlexboxGrid.Item>
            </FlexboxGrid>
            <Modal backdrop="static" keyboard={false} open={working} size="xs" className="custom-working">
                <Modal.Body style={{ textAlign: "center", height: 80 }}>
                    <RingLoader color={"#ffffff"} />
                </Modal.Body>
            </Modal>
        </>
    );
}
export default LoginPage;